import { s3upload } from '../utils/fileUpload';

const DEFAULT_MEDIA_PATH = 'images/machines/';

export const uploadOfflineImageAttachments = async ({ attachments = [], meta = {} }) => {
	if (!attachments.length) {
		return [];
	}

	const { serverEndpoint, s3Path: metaS3Path } = meta;
	const s3Path = metaS3Path || DEFAULT_MEDIA_PATH;

	const getEndpoint = async () => {
		if (typeof serverEndpoint === 'string' && serverEndpoint.length) {
			return serverEndpoint;
		}

		throw new Error('Missing server endpoint for offline upload');
	};

	const uploaded = [];

	// sequential uploading to reduce memory pressure
	for (const attachment of attachments) {
		const localUri = attachment.localUri || attachment.uri;

		if (!localUri) {
			continue;
		}

		const result = await s3upload(
			{ uri: localUri },
			undefined,
			s3Path,
			getEndpoint,
			localUri,
			attachment.mediaType,
			undefined,
			true,
		);

		if (!result) {
			throw new Error('Failed to upload media');
		}

		uploaded.push({
			remoteUrl: result,
			localUri,
		});
	}

	return uploaded;
};

export const filterRemoteUrls = urls => (urls || []).filter(url => typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://')));
